$(document).ready(function () {

  var emojiStringToArray = function (str) {
    split = str.split(/([\uD800-\uDBFF][\uDC00-\uDFFF])/);
    arr = [];
    for (var i = 0; i < split.length; i++) {
      char = split[i]
      if (char !== "") {
        arr.push(char);
      }
    }
    return arr;
  };

  $('#emojionearea1').emojioneArea({
    pickerPosition: 'bottom',
    tonesStyle: 'bullet',
    placeholder: 'Digite o nome da pasta',
    emojiPlaceholder: ':smile_cat:',
    searchPlaceholder: 'Buscar',
    searchPosition: 'bottom',
    inline: true,
    maxCount: 1,
    events: {
      keyup: function (editor, event) {
        console.log(editor.html());
        console.log(this.getText());
      },
    },
  });

  $('#divOutside').click(function () {
    $('.emojionearea-button').click();
  });
});

$('#lala').click(function () {
  alert($('#emojionearea1').val());
  $('#nnnnn').append($('#emojionearea1').val());
});
